import React from "react";
import EarlyAccessButton from "../EarlyAccessButton";
import styles from "./styles.module.scss";

/**
 * AgenticMemorySection组件的属性接口
 */
interface AgenticMemorySectionProps {
  onDownloadClick: () => void;
}

/**
 * AgenticMemorySection组件 - 展示Agentic Memory功能的部分
 * @param onDownloadClick 下载按钮点击回调函数
 * @returns 渲染的组件
 */
const AgenticMemorySection: React.FC<AgenticMemorySectionProps> = ({ onDownloadClick }) => {
  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        {/* 左侧部分 - 文本内容 */}
        <div className={styles.textContentSection}>
          <div className={styles.textContentInner}>
            <h2 className={styles.mainTitle}>
              <div className={styles.titleLine}>
                Fellou is for <span className={styles.highlight}>Productivity.</span>
              </div>
            </h2>

            <div className={styles.secondPhaseText}>
              <div className={styles.secondPhaseLine}>Your browser and desktop,</div>
              <div className={styles.secondPhaseLine}>working together seamlessly.</div>
            </div>

            <EarlyAccessButton onClick={onDownloadClick} />
          </div>
        </div>

        {/* 右侧部分 - 视频展示（替代动画演示） */}
        <div className={styles.videoSection}>
          <div className={styles.videoContainer}>
            <video autoPlay muted loop playsInline className={styles.videoElement}>
              <source
                src="https://fellou.s3.us-west-1.amazonaws.com/videos/website-main-page/Website+main+page+animation/Computer+USE.webm"
                type="video/webm"
              />
            </video>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgenticMemorySection;
